import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DropdownSelect } from "../../../core/components/dropdown/DropdownSelect";
import { InfoText } from "../../../core/components/texts/InfoText";
import { getLanguage } from "../../../core/store/appSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { OnboardingScreenContainer } from "../../onboarding/OnboardingScreenContainer";

export const CheckInInfoScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNext = async () => {
    navigate(`/welcome/login`);
  };
  const handleBack = () => {
    navigate(`/welcome`);
  };

  const language = useMainStore(getLanguage);
  const setLanguage = useMainStore((state) => state.setLanguage);

  const languageOptions = [
    { value: "de", label: "Deutsch" },
    { value: "tr", label: "Türkçe" },
    { value: "en", label: "English" },
  ];

  const selectedLanguageOption =
    languageOptions.find((option) => option.value === language)?.label ||
    languageOptions[0].label;

  return (
    <OnboardingScreenContainer
      handleBack={handleBack}
      nextButton={{
        onClick: handleNext,
        text: t("CHECK_IN_START"),
      }}
    >
      <InfoText
        headline={t("CHECKIN_HEADLINE")}
        text={[t("CHECKIN_DESCRIPTION")]}
      />
      <DropdownSelect
        value={selectedLanguageOption}
        options={languageOptions}
        onChange={(_label, value) => {
          setLanguage(
            value as
              | "de"
              | "en"
              | "tr"
              | "cs"
              | "ru"
              | "hr"
              | "es"
              | "fr"
              | "it"
              | "sq",
          );
        }}
        withoutError
      />
    </OnboardingScreenContainer>
  );
};
